export default "__VITE_ASSET__6e693d6c__"